import messageListLayoutStore from '../messageListLayoutStore';
import getFallbackPreviewLinesToShow from '../../utils/getFallbackPreviewLinesToShow';

export default function getShowPreviewLinesInListView(): number {
    const messagePreviewStore = messageListLayoutStore();
    return messagePreviewStore.showPreviewLinesInListView ?? getFallbackPreviewLinesToShow();
}
